import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { MessagesApp } from '@mews-commander/modules/src/modules/messages';
import { CommunicationHub } from '@mews-commander/modules/src/modules/messagesNew';
import { MewsTeam, RouteType } from '@mews/enums';
import { useFeatureFlag } from '@mews/framework';

const Component = () => {
    const communicationHubPageEnabled = useFeatureFlag(FeatureFlag.communicationHubEnabled);
    return communicationHubPageEnabled ? (
        <CommunicationHub />
    ) : (
        <MessagesApp guideLink={createGuideLink(ArticlePath.ReadReplyMessages)} />
    );
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/MessageThread/Index/')({
    component: Component,
    staticData: {
        title: TextKey.MessagePlural,
        routeName: RouteName.MessageThreadIndex,
        owner: MewsTeam.Accounts,
        type: RouteType.Frontend,
    },
});
